/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
  Button,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import moment from 'moment';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

function Search(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const location = useLocation();
  const [query, setQuery] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    setQuery(queryParams.get('q').trim());

    document.title = t(`Search "${queryParams.get('q')}"`);
  }, [location.search]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {query && (
          <>
            <Row>
              <Col xxl="6">
                <Card>
                  <CardHeader className="border-bottom bg-transparent">{t('Sales')}</CardHeader>
                  <CardBody>
                    <Can i="see" this="Sales">
                      <BaseGrid
                        url="/api/sales"
                        className="table table-sm table-hover table-striped table-bordered fs-6"
                        search={query}
                        config={
                        {
                          columns: {
                            id: {
                              label: 'ID',
                              sort: true,
                              link: {
                                to: '/sales/%id%',
                              },
                            },
                            created_at: {
                              label: 'Imported',
                              date: {
                                format: (date) => (moment(date).fromNow()),
                                timezone: process.env.LOCAL_TZ,
                              },
                              sort: true,
                              style: { fontSize: '11px' },
                            },
                            reference1: {
                              label: 'Ref 1',
                              html: true,
                              sort: true,
                              format: (e, x) => {
                                if (x.canceled_at !== null) {
                                  return `<strike class="text-danger">${x.reference1}</strike>`;
                                }

                                return x.reference1;
                              },
                            },
                            site: { label: 'Site', sort: false, style: { fontSize: '10px' } },
                            customer_email: { label: 'Email', sort: true },
                            // eslint-disable-next-line max-len
                            // customer_note: { label: 'Customer Note', sort: false, style: { width: '150px' } },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 5,
                          },
                        }
                        }
                      />
                    </Can>

                    <Can not i="see" this="Sales"><p>{props.t('Unauthorized')}</p></Can>
                  </CardBody>
                </Card>
              </Col>

              <Col xxl="6">
                <Card>
                  <CardHeader className="border-bottom bg-transparent">{t('Items')}</CardHeader>
                  <CardBody>
                    <Can i="see" this="Items">
                      <BaseGrid
                        url="/api/items"
                        className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                        search={query}
                        config={
                        {
                          columns: {
                            thumb: {
                              label: '',
                              image: {
                                src: (item) => (`/api/items/thumbnail/${item.id}`),
                                class: 'rounded',
                                style: { maxHeight: '3rem', maxWidth: '3rem' },
                              },
                              translate: false,
                            },
                            id: {
                              label: props.t('ID'),
                              sort: true,
                              link: {
                                to: '/item/%id%',
                              },
                            },
                            manufacturer: {
                              label: props.t('Manufacturer'),
                              sort: true,
                            },
                            part_number: {
                              label: props.t('Part Number'),
                              sort: true,
                              link: {
                                to: '/item/%id%',
                              },
                            },
                            condition: {
                              label: props.t('Condition'),
                              sort: true,
                            },
                            tags: {
                              label: 'Tags',
                              format: (x) => (x.map((r) => (r.label))),
                              badges: {
                                class: 'bg-info bg-soft text-dark p-1',
                              },
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 5,
                          },
                        }
                        }
                      />
                    </Can>

                    <Can not i="see" this="Items"><p>{props.t('Unauthorized')}</p></Can>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col xxl="6">
                <Card>
                  <CardHeader className="border-bottom bg-transparent">{t('Listings')}</CardHeader>
                  <CardBody>
                    <Can i="see" this="Listings">
                      <BaseGrid
                        url="/api/listings"
                        search={query}
                        className="table table-sm table-hover table-bordered fs-6"
                        config={
                        {
                          columns: {
                            thumb: {
                              label: '',
                              image: {
                                src: (listing) => (`/api/listings/thumbnail/${listing.id}`),
                                class: 'rounded',
                                style: { maxHeight: '5rem', maxWidth: '5rem' },
                              },
                              translate: false,
                            },
                            id: {
                              label: 'ID',
                              sort: true,
                              style: { minWidth: '100px' },
                              link: {
                                to: '/listing/%id%',
                              },
                              html: true,
                              format: (x, lst) => {
                                const test = lst.items
                                  .map((y) => (y.qty && y.qty > y.item_qty))
                                  .filter((y) => y);

                                if (test.length === lst.items.length) {
                                  // In Stock
                                  return `<span class="badge bg-success"><span class="mdi mdi-check"></span></span> &nbsp;${x}`;
                                }

                                // OOS
                                return `<span class="badge bg-warning bg-soft"><span class="mdi mdi-close-thick text-dark"></span></span> &nbsp;${x}`;
                              },
                            },
                            sku: {
                              label: 'Sku',
                              sort: true,
                            },
                            title: { label: 'Title', sort: true, style: { fontSize: '11px', maxWidth: '200px' } },
                            condition: { label: 'Condition', sort: true, style: { fontSize: '11px' } },
                            price: {
                              label: 'Price',
                              sort: false,
                              format: (x) => new Intl.NumberFormat(
                                'en-US',
                                {
                                  style: 'currency',
                                  currency: 'USD',
                                },
                              ).format(x),
                              style: { fontSize: '11px' },
                            },
                            tags: {
                              label: 'Tags',
                              format: (x) => (x.map((r) => (r.label))),
                              badges: {
                                class: 'bg-info bg-soft text-dark p-1',
                              },
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 5,
                          },
                        }
                        }
                      />
                    </Can>

                    <Can not i="see" this="Listings"><p>{props.t('Unauthorized')}</p></Can>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
}

Search.defaultProps = {
  t: (x) => (x),
};

Search.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Search));
